module.exports = __webpack_public_path__ + "img/pin.87c4461e.svg";